module.exports = __webpack_public_path__ + "themes/fq/img/frame-center-spec-overlay@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/frame-center-spec-overlay@2x.png
// module id = 4
// module chunks = d-game